"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowFormStateSchema = exports.WorkflowFormInputSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.WorkflowFormInputSchema = zod_1.default.object({
    form: zod_1.default.string({
        description: 'Form definition ID',
    }),
    prompt: zod_1.default.string({
        description: 'Langfuse prompt ID',
    }),
});
exports.WorkflowFormStateSchema = zod_1.default.object({
    prompt: zod_1.default.string({ description: 'The final interview prompt' }),
    form: zod_1.default.string({ description: 'The form ID' }),
});
//# sourceMappingURL=workflowFormSchema.js.map